export const TutorialActionTypes = {
  ASYNC_TUTORIALS_LIST: '@tutorial/ASYNC_TUTORIALS_LIST',
  CHANGE_TUTORIALS_LIST: '@tutorial/CHANGE_TUTORIALS_LIST',
  ASYNC_TUTORIAL: '@tutorial/ASYNC_TUTORIAL',
  CHANGE_TUTORIAL: '@tutorial/CHANGE_TUTORIAL',
  SET_LOADING_LIST: '@tutorial/SET_LOADING_LIST',
};

const INITIAL_STATE = {
  tutorialsList: {
    items: [],
    total: 0,
  },
  tutorial: {},
  loadingList: false,
}

const TutorialReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TutorialActionTypes.CHANGE_TUTORIALS_LIST:
      return { ...state, tutorialsList: payload };
    case TutorialActionTypes.CHANGE_TUTORIAL:
      return { ...state, tutorial: payload };
    case TutorialActionTypes.SET_LOADING_LIST:
      return { ...state, loadingList: payload };
    default:
      return state;
  }
}

export const asyncTutorialList = (payload) => ({
  type: TutorialActionTypes.ASYNC_TUTORIALS_LIST,
  payload,
});

export const changeTutorialList = (payload) => ({
  type: TutorialActionTypes.CHANGE_TUTORIALS_LIST,
  payload,
});

export const changeTutorial = (payload) => ({
  type: TutorialActionTypes.CHANGE_TUTORIAL,
  payload
});

export const asyncTutorial = (payload) => ({
  type: TutorialActionTypes.ASYNC_TUTORIAL,
  payload
});

export const setLoadingList = (payload) => ({
  type: TutorialActionTypes.SET_LOADING_LIST,
  payload,
});

export default TutorialReducer;
